import { Children, createElement, cloneElement } from 'react';
import { string, node } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import 'reakit/Paragraph';
import '../Paragraph/styled.js';
import '../Paragraph/index.js';
import _isArrayLikeObject from 'lodash/isArrayLikeObject';
import { Timeline as Timeline$1 } from './styled.js';
import TimelineStep from './TimelineStep.js';
export { default as TimelineStep, timelineStepDefaultProps, timelineStepPropTypes } from './TimelineStep.js';
import TimelineStepDetail from './TimelineStepDetail.js';
export { default as TimelineStepDetail, timelineStepDetailDefaultProps, timelineStepDetailPropTypes } from './TimelineStepDetail.js';
import TimelineStepHeading from './TimelineStepHeading.js';
export { default as TimelineStepHeading, timelineStepHeadingDefaultProps, timelineStepHeadingPropTypes } from './TimelineStepHeading.js';
/* eslint react/prop-types: 0 */

var Timeline = function Timeline(_ref) {
  var activeStep = _ref.activeStep,
      children = _ref.children,
      progressColor = _ref.progressColor;

  if (!_isArrayLikeObject(children)) {
    return null;
  }

  var activeIndexStep = Children.toArray(children).findIndex(function (child) {
    return child.props.a11yTitleId === activeStep;
  });
  return createElement(Timeline$1, null, Children.map(children, function (child, index) {
    var _child = child;
    var color = progressColor ? progressColor : _child.props.progressColor;
    return index <= activeIndexStep ? cloneElement(_child, {
      lineColor: index < activeIndexStep ? color : undefined,
      progressColor: color || undefined
    }) : child;
  }));
};

Timeline.Step = TimelineStep;
Timeline.StepHeading = TimelineStepHeading;
Timeline.StepDetail = TimelineStepDetail;
var timelinePropTypes = {
  activeStep: string,
  children: node.isRequired,
  progressColor: string
};
var timelineDefaultProps = {
  activeStep: undefined,
  progressColor: undefined
};
Timeline.defaultProps = timelineDefaultProps; // @ts-ignore

var C = Timeline;
export default C;
export { C as Timeline, timelineDefaultProps, timelinePropTypes };